var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GenericSubMenu',{attrs:{"options":_vm.options},on:{"select":function (selection) { return _vm.$emit('select', selection); }}})}
var staticRenderFns = []

export { render, staticRenderFns }